import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
   Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TablePagination,
  CircularProgress,
  TextField,
  Autocomplete
} from '@mui/material';
import { authenticationService } from 'src/services';
import { deleteEntry, get, post,put } from 'src/services/httpClient.service';
import { useSnackbar } from 'src/components/snackbar/useSnackbar';

const Blockedsubscribers = () => {
  const { showSnackbar } = useSnackbar();
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState<number[]>([]);
  const [statusFilter, setStatusFilter] = useState('BLOCKELISTED');
  const { vendorId, franchiseId, companyId, operatorId } = authenticationService.getVendorFranchiseIds();
  const API_URL = process.env.REACT_APP_BASE_API_URL;
  const [openBlockDialog, setOpenBlockDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [subscriptionData, setSubscriptionData] = useState<any>(null);
  const [confirmBlockOpen, setConfirmBlockOpen] = useState(false);
  const [blocking, setBlocking] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [userList, setUserList] = useState<any[]>([]);





  const [page, setPage] = useState(0);
const [rowsPerPage, setRowsPerPage] = useState(10);

const handleChangePage = (
  event: unknown,
  newPage: number
) => {
  setPage(newPage);
};

const handleChangeRowsPerPage = (
  event: React.ChangeEvent<HTMLInputElement>
) => {
  setRowsPerPage(parseInt(event.target.value, 10));
  setPage(0);
};

const filteredUsers = users.filter((user: any) => {
  const search = searchText.toLowerCase();

  return (
    user.customerId?.toLowerCase()?.includes(search) ||
    `${user.firstName || ''} ${user.lastName || ''}`
      .toLowerCase()
      .includes(search) ||
    user.phone?.toString()?.toLowerCase()?.includes(search)
  );
});
  
  const fetchUsers = async () => {
  try {
    //const response = await get(`${API_URL}/api/subscriber/vendor/${vendorId}/getSubscribersByVendor`);
    const response = await get(`${API_URL}/api/subscriber/vendor/${vendorId}/blacklisted-users`);

    const userList = response?.userList || [];

    // const filteredUsers = userList.filter(
    //   (user) => user.status?.toUpperCase() === statusFilter
    // );

    setUsers(userList);
  } catch (error) {
    console.error('Error fetching users:', error);
  }
};

  useEffect(() => {
    fetchUsers();
  }, [statusFilter]);

  

  const handleCheckboxChange = (userId: number) => {
    setSelectedUsers((prev) =>
      prev.includes(userId)
        ? prev.filter((id) => id !== userId)
        : [...prev, userId]
    );
  };

  
/* const userlistdata = async () => {
   const data = await `${API_URL}/usersubscription/vendor/${vendorId}/franchise/null/getUserLatestSubscription?userId=${user.userId}`
} */

   const fetchUserList = async () => {
  try {
    const response = await get(
      `${API_URL}/api/subscriber/vendor/${vendorId}/getSubscribersByVendor`
    );

    const users = (response?.userList || []).filter(
      (user: any) =>
        ['ACTIVE', 'INACTIVE'].includes(
          user.status?.toUpperCase()
        )
    );

    setUserList(users);
  } catch (error) {
    console.error('Error fetching users:', error);
  }
};

useEffect(() => {
  fetchUserList();
}, []);

const handleConfirmBlock = async () => {
  try {
    setBlocking(true);

    const payload = {
      
      customerId: selectedUser.customerId
    };

    const response = await post(
      `${API_URL}/api/subscriber/vendor/${vendorId}/blacklist`, {customerId : payload['customerId']}
    );

    if (response?.status === 'OK') {
      showSnackbar(
        'Subscriber blocked successfully',
        'success'
      );

      setConfirmBlockOpen(false);
      setOpenBlockDialog(false);

      setSelectedUsers([]);
      setSelectedUser(null);
      setSubscriptionData(null);

      fetchUsers();
    } else {
      showSnackbar(
        response?.responseMessage ||
          'Failed to block subscriber',
        'error'
      );
    }
  } catch (error) {
    console.error('Block User Error:', error);

    showSnackbar(
      'Failed to block subscriber',
      'error'
    );
  } finally {
    setBlocking(false);
  }
};



  return (
    <Box p={2}>
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          mb: 2
        }}
      >
        

        <Autocomplete
  sx={{ width: 450 }}
  options={userList}
  getOptionLabel={(option) =>
    `${option.customerId} - ${option.firstName || ''} ${option.lastName || ''}`
  }
  onChange={(event, value) => {
    setSelectedUser(value);
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Select User"
      size="small"
    />
  )}
/>
       {selectedUser && (
  <Button
    variant="contained"
    color="error"
    onClick={async () => {
      try {
        const subscriptionRes = await get(
          `${API_URL}/usersubscription/vendor/${vendorId}/franchise/null/getUserLatestSubscription?userId=${selectedUser.userId}`
        );

        setSubscriptionData(
          subscriptionRes?.data?.user_subscription
        );

        setOpenBlockDialog(true);
      } catch (error) {
        console.error(error);
        setOpenBlockDialog(true);
      }
    }}
  >
    Block User
  </Button>
)}
      </Box>

      <Box
  sx={{
    display: 'flex',
    justifyContent: 'flex-end',
    mb: 2
  }}
>
  <TextField
    size="small"
    label="Search Blocked Users"
    value={searchText}
    onChange={(e) => {
      setSearchText(e.target.value);
      setPage(0);
    }}
    sx={{ width: 300 }}
  />
</Box>

      <TableContainer component={Paper} 
  sx={{
    maxHeight:400
  }}>
        <Table size="small">
          {/* <TableHead>
            <TableRow>
              {(statusFilter === 'ACTIVE' ||
                statusFilter === 'INACTIVE') && (
                <TableCell>Select</TableCell>
              )}

              <TableCell>Customer ID</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Phone</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead> */}

          <TableHead>
  <TableRow>
    {(statusFilter === 'ACTIVE' ||
      statusFilter === 'INACTIVE') && (
      <TableCell sx={{ py: 1 }}>Select</TableCell>
    )}

    <TableCell sx={{ py: 1 }}>Customer ID</TableCell>
    <TableCell sx={{ py: 1 }}>Name</TableCell>
    <TableCell sx={{ py: 1 }}>Phone</TableCell>
    <TableCell sx={{ py: 1 }}>Status</TableCell>
  </TableRow>
</TableHead>

          {/* <TableBody>
            {users.map((row: any) => (
              <TableRow key={row.userId}>
                {(statusFilter === 'ACTIVE' ||
                  statusFilter === 'INACTIVE') && (
                  <TableCell>
                    <Checkbox
                      checked={selectedUsers.includes(row.userId)}
                      onChange={() =>
                        handleCheckboxChange(row.userId)
                      }
                    />
                  </TableCell>
                )}

                <TableCell>{row.customerId}</TableCell>
                <TableCell>
                  {row.firstName} {row.lastName}
                </TableCell>
                <TableCell>{row.phone}</TableCell>
                <TableCell>{row.status}</TableCell>
              </TableRow>
            ))}
          </TableBody> */}
          <TableBody>
  {filteredUsers
    .slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    )
    .map((row: any) => (
      <TableRow key={row.userId}>
        {(statusFilter === 'ACTIVE' ||
          statusFilter === 'INACTIVE') && (
          <TableCell sx={{ py: 0.5 }}>
            <Checkbox
              size="small"
              checked={selectedUsers.includes(row.userId)}
              onChange={() =>
                handleCheckboxChange(row.userId)
              }
            />
          </TableCell>
        )}

        <TableCell sx={{ py: 0.5 }}>
          {row.customerId}
        </TableCell>

        <TableCell sx={{ py: 0.5 }}>
          {row.firstName} {row.lastName}
        </TableCell>

        <TableCell sx={{ py: 0.5 }}>
          {row.phone}
        </TableCell>

        <TableCell sx={{ py: 0.5 }}>
          {row.status}
        </TableCell>
      </TableRow>
    ))}
</TableBody>

        </Table>
      </TableContainer>
      <TablePagination
  component="div"
  count={filteredUsers.length}
  page={page}
  onPageChange={handleChangePage}
  rowsPerPage={rowsPerPage}
  onRowsPerPageChange={handleChangeRowsPerPage}
  rowsPerPageOptions={[10, 25, 50]}
/>

<Dialog
  open={confirmBlockOpen}
  onClose={() => setConfirmBlockOpen(false)}
  maxWidth="xs"
  fullWidth
>
  <DialogTitle>
    Confirm Block
  </DialogTitle>

  <DialogContent>
    <DialogContentText>
      Are you sure you want to block subscriberss
      <br />
      <strong>
        {selectedUser?.firstName} {selectedUser?.lastName}
      </strong>
      ?
    </DialogContentText>
  </DialogContent>

  <DialogActions>
    <Button
      onClick={() => setConfirmBlockOpen(false)}
    >
      No
    </Button>

    <Button
  color="error"
  variant="contained"
  onClick={handleConfirmBlock}
  disabled={blocking}
>
  {blocking ? (
    <>
      <CircularProgress
        size={18}
        color="inherit"
        sx={{ mr: 1 }}
      />
      Blocking...
    </>
  ) : (
    'Yes, Block'
  )}
</Button>
  </DialogActions>
</Dialog>

      <Dialog
  open={openBlockDialog}
   maxWidth="lg"
  onClose={() => setOpenBlockDialog(false)}
>
  <DialogTitle>
    Block Subscriber
  </DialogTitle>

  <DialogContent>
    <DialogContentText sx={{ mb: 2 }}>
      Are you sure you want to block this subscriber?
    </DialogContentText>

    <Box>
      <strong>Customer ID:</strong>{' '}
      {selectedUser?.customerId}
    </Box>

    <Box sx={{ mt: 1 }}>
      <strong>User Name:</strong>{' '}
      {selectedUser?.firstName} {selectedUser?.lastName}
    </Box>

    <Box sx={{ mt: 2 }}>
  <strong>Packages:</strong>
</Box>

<Box sx={{ mt: 2 }}>
  <strong>Subscription Plan:</strong>{' '}
  {subscriptionData?.subscriptionPlan}
</Box>

<Box sx={{ mt: 1 }}>
  <strong>Plan Type:</strong>{' '}
  {subscriptionData?.planType}
</Box>

<Box sx={{ mt: 1 }}>
  <strong>Plan Amount:</strong>{' '}
  ₹{subscriptionData?.planAmount}
</Box>

<Box sx={{ mt: 1 }}>
  <strong>Start Date:</strong>{' '}
  {subscriptionData?.startDate?.split('T')[0]}
</Box>

<Box sx={{ mt: 1 }}>
  <strong>End Date:</strong>{' '}
  {subscriptionData?.endDate?.split('T')[0]}
</Box>

<Box sx={{ mt: 2 }}>
  <strong>Packages:</strong>
</Box>


{subscriptionData?.packageList?.length > 0 ? (
  subscriptionData.packageList.map(
    (pkg: any, index: number) => (
      <Box
        key={index}
        sx={{
          ml: 2,
          mt: 1,
          p: 1,
          border: '1px solid #ddd',
          borderRadius: 1
        }}
      >
        {pkg.packageName}
      </Box>
    )
  )
) : (
  <Box sx={{ ml: 2, mt: 1 }}>
    No Package Found
  </Box>
)}
  </DialogContent>

  <DialogActions>
    <Button
      onClick={() => setOpenBlockDialog(false)}
    >
      Cancel
    </Button>

   <Button
  color="error"
  variant="contained"
  onClick={() => setConfirmBlockOpen(true)}
>
  Block
</Button>
  </DialogActions>
</Dialog>
    </Box>
  );
};

export default Blockedsubscribers;